
import { defineComponent, reactive, ref, watch } from "vue";
import BaseRoundRectButton from "@/components/atoms/BaseRoundRectButton.vue";
import TextField from "@/components/atoms/TextField.vue";
import { LocalizationError } from "@/error/error";
import { CommunicationState } from "@/type";

export default defineComponent({
  name: "PasswordResetRequestScreen",
  components: {
    BaseRoundRectButton,
    TextField,
  },
  props: {
    localizationError: {
      type: Object as () => LocalizationError | null,
      default: null,
      required: false,
    },
    successMessage: {
      type: String,
      default: "",
      required: false,
    },
    communicationState: {
      type: Object as () => CommunicationState,
      default: 1,
      required: true,
    },
  },
  emits: {
    requestPasswordReset: (request: { email: string }) => {
      if (request != null) return true;
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      email: "",
      validationError: "",
    });

    const isLoading = ref<boolean>(false);

    watch(
      () => props.communicationState,
      () => {
        if (props.communicationState === 2) {
          isLoading.value = true;
        } else {
          isLoading.value = false;
        }
      }
    );

    function validateEmail(email: string): boolean {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }

    function handleSubmit() {
      state.validationError = "";

      if (!state.email) {
        state.validationError = "メールアドレスを入力してください";
        return;
      }

      if (!validateEmail(state.email)) {
        state.validationError = "有効なメールアドレスを入力してください";
        return;
      }

      emit("requestPasswordReset", { email: state.email });
    }

    function handleClose() {
      window.close();
    }

    return {
      state,
      isLoading,
      handleSubmit,
      handleClose,
    };
  },
});
